
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/post-event-resources",
      function () {
        return require("private-next-pages/world/post-event-resources.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/post-event-resources"])
      });
    }
  